import { render, staticRenderFns } from "./OccurrenceDetailModal.vue?vue&type=template&id=b37ee166&scoped=true&"
import script from "./OccurrenceDetailModal.vue?vue&type=script&lang=js&"
export * from "./OccurrenceDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceDetailModal.vue?vue&type=style&index=0&id=b37ee166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37ee166",
  null
  
)

export default component.exports